var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectoryNoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 27.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.949,26.71H15.375l-1.6-3.019a1.1,1.1,0,0,0-.972-.59h-9.2a1.1,1.1,0,0,0-1.11,1.11V45.1a1.1,1.1,0,0,0,1.11,1.11H29.947a1.1,1.1,0,0,0,1.11-1.11V27.82a1.119,1.119,0,0,0-1.11-1.11Z",
    transform: "translate(-2.5 -18.694)",
    fill: "#1fa0ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.278,14.008H24.969l-1.6-3.019a1.1,1.1,0,0,0-.972-.59H14.212a1.11,1.11,0,1,0,0,2.22h7.53l1.6,3.019a1.1,1.1,0,0,0,.972.59H40.2v16.9a1.11,1.11,0,1,0,2.22,0V15.118a1.173,1.173,0,0,0-1.145-1.11Z",
    transform: "translate(-9.423 -10.399)",
    fill: "#1fa0ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryNoCircle);
export default __webpack_public_path__ + "static/media/directory-no-circle.524e12fd96444f00081c384220d1c16c.svg";
export { ForwardRef as ReactComponent };